export enum EmployerContributionType {
  SelectedPlan = 1,
  AnyPlan = 2,
  LowestCostPlan = 3,
  NoContribution = 4
}